module.exports = __webpack_public_path__ + "img/tarj1-5.2f159a9c.svg";